export const getIsSnackbarVisible = state => state.snackbar.get('isVisible')
export const getSnackbarMessage = state => state.snackbar.get('message')
